<template>
  <div class="bottomVert" v-if="detailReseauxLc.listeFaces.length">
    <gmap-map
      class="infoBorder gmap"
      :center="{
        lat: detailReseauxLc.latitude,
        lng: detailReseauxLc.longitude
      }"
      :zoom="12"
      :options="{
        mapTypeControlOptions: mapType,
      }"
      ref="mapReseauxLc"
      @tilesloaded="initCarto">
      <gmap-marker
        v-for="(m, index) in detailReseauxLc.listeFaces"
        :key="index"
        :clickable="true"
        :position="{
          lat: m.latitude,
          lng: m.longitude
        }"
        @click="detailFace = m, show = true"
        @mouseover="handleMarkerHover(m, index)"
        :icon="icon(detailReseauxLc.couleur, m.azimut)">
      </gmap-marker>
      <gmap-marker
        v-if="markerReseauxLc.lat"
        :position="{
          lat: markerReseauxLc.lat,
          lng: markerReseauxLc.lng,
        }"
        :icon="markerReseauxLc.icon">
      </gmap-marker>

      <gmap-info-window
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen = false"
      >
        <div v-html="infoContent"></div>
      </gmap-info-window>
    </gmap-map>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutRight"
      :duration="300"
      v-on:after-enter="bg = true"
      v-on:after-leave="bg = false">
      <app-detail-reseaux-lc-complet
        :bg="bg"
        :detailReseauxLcComplet="detailFace"
        v-if="show"/>
    </transition>
  </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps';
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/general/iconColorGetter';
import {
  MAP_TYPE_CONTROL_OPTIONS,
  STYLE_MAPS_POI_HIDDEN, MAP_TYPE_NAME,
} from '@/configurations/configurationCarto';
import filterLatLng from '@/services/general/gestionLatLng';
import fullscreenPopupMixin from '@/services/general/fullscreenPopupMixin';
import detailReseauxLcComplet from './detailReseauxLcComplet';

export default {
  name: 'carteReseauxLc',
  mixins: [fullscreenPopupMixin],
  components: {
    appDetailReseauxLcComplet: detailReseauxLcComplet,
  },
  computed: {
    google: gmapApi,
  },
  props: ['detailReseauxLc', 'markerReseauxLc'],
  data() {
    return {
      detailFace: {},
      show: false,
      colorIcon: '#0062b1',
      bg: false,
      isLoadOnce: false,
      mapType: MAP_TYPE_CONTROL_OPTIONS,
    };
  },
  methods: {
    async levelZoom() {
      const bounds = new google.maps.LatLngBounds();
      filterLatLng(this.detailReseauxLc.listeFaces);
      this.detailReseauxLc.listeFaces.forEach(m => {
        if (m.latitude !== 0 && m.longitude !== 0
        && m.latitude !== null && m.longitude !== null) {
          bounds.extend({ lat: m.latitude, lng: m.longitude });
        }
      });
      if (this.markerReseauxLc !== undefined && this.markerReseauxLc.lat !== undefined) {
        bounds.extend({ lat: this.markerReseauxLc.lat, lng: this.markerReseauxLc.lng });
      }
      this.$refs.mapReseauxLc.fitBounds(bounds);
    },
    icon(color, azimut) {
      if (!color) return iconColorGetter(this.colorIcon, TAILLE_ICON_GRAND, azimut, true);
      return iconColorGetter(color, TAILLE_ICON_GRAND, azimut, true);
    },
    async initPoi() {
      const map = await this.$refs.mapReseauxLc.$mapPromise;
      const styleMap = new google.maps.StyledMapType(STYLE_MAPS_POI_HIDDEN, {
        name: MAP_TYPE_NAME,
      });
      map.mapTypes.set('styled_map', styleMap);
    },
    async initCarto() {
      if (!this.isLoadOnce) {
        await this.initPoi();
        if (this.detailReseauxLc.listeFaces.length) {
          await this.levelZoom();
        }
        this.isLoadOnce = true;
      }
    },
    getInfoWindowContent(marker) {
      const adresse = this.buildAdresse(marker);

      return (
        `<div style="padding:15px" class="card">
          <div class="">
            <div class="columns">
              <div class="column is-6">
                <p>Code Face : <strong>${marker.facCode || ''}</strong></p>
                <p>Réseau : <strong>${this.detailReseauxLc.libelle || ''}</strong></p>
                <p>Adresse : <strong>${adresse}</strong></p>
                <p>Format : <strong>${marker.format || ''}</strong></p>
              </div>
              <div class="column">
                <img style="width:100%"
                    src="${marker.urlPhoto ? marker.urlPhoto : this.defaultPlaceholder}"/>
              </div>
            </div>
          </div>
        </div>`);
    },
  },
  mounted() {
    if (this.detailReseauxLc.latitude === null || this.detailReseauxLc.longitude === null) {
      this.detailReseauxLc.latitude = 0;
      this.detailReseauxLc.longitude = 0;
    }
    this.setupFullscreenListeners();
  },
  beforeDestroy() {
    this.removeFullscreenListeners();
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/reseauxLc/carteReseauxLc.vue